var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverPayoutActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7301",
    "data-name": "Group 7301",
    transform: "translate(6092 8622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7299",
    "data-name": "Group 7299",
    transform: "translate(8 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7298",
    "data-name": "Group 7298",
    transform: "translate(-6100 -8613.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7263",
    "data-name": "Path 7263",
    d: "M12.745,95.86a.827.827,0,0,0-.379-.389l-2.595-1.3a.168.168,0,0,0-.077-.018.173.173,0,0,0-.1.033,4.217,4.217,0,0,1-5,0,.174.174,0,0,0-.178-.015l-2.6,1.3a.827.827,0,0,0-.379.389L0,99a10.559,10.559,0,0,0,2.488,1.635h.14v-.208a2.646,2.646,0,0,1,.921-1.456,4.675,4.675,0,0,1,1.8-.931,6.335,6.335,0,0,1,1.418-.233H7.19a6.421,6.421,0,0,1,1.664.218,4.5,4.5,0,0,1,2.074,1.2,2.5,2.5,0,0,1,.755,1.377v.033H11.7A10.581,10.581,0,0,0,14.192,99Z",
    transform: "translate(0 -86.485)",
    fill: "#04be76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7264",
    "data-name": "Path 7264",
    d: "M48.106,0C45.9,0,44.79,1.261,44.79,3.745a3.341,3.341,0,1,0,6.634,0C51.424,1.261,50.307,0,48.106,0Z",
    transform: "translate(-41.013 0)",
    fill: "#04be76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7265",
    "data-name": "Path 7265",
    d: "M48.957,152.67a1.189,1.189,0,0,1-.016.2,10.916,10.916,0,0,1-7.2.031,1.218,1.218,0,0,1-.022-.229c0-1.154,1.62-2.09,3.618-2.09S48.957,151.515,48.957,152.67Z",
    transform: "translate(-38.202 -138.321)",
    fill: "#04be76"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11212",
    "data-name": "Path 11212",
    d: "M246.965.063A4.967,4.967,0,0,0,242,5.03V9.4a.6.6,0,0,0,.6.6h4.368a4.967,4.967,0,1,0,0-9.935Zm.266,6.914v.337a.312.312,0,1,1-.624,0V7.021a2.939,2.939,0,0,1-.738-.128.39.39,0,0,1-.261-.468l.008-.029a.342.342,0,0,1,.445-.238,2.152,2.152,0,0,0,.712.126c.362,0,.611-.14.611-.395s-.2-.394-.674-.553c-.681-.229-1.146-.547-1.146-1.164a1.175,1.175,0,0,1,1.076-1.132V2.746a.311.311,0,1,1,.623,0v.248a2.721,2.721,0,0,1,.575.082.37.37,0,0,1,.265.45l-.006.023a.343.343,0,0,1-.432.243,1.956,1.956,0,0,0-.579-.085c-.413,0-.547.178-.547.356,0,.21.222.343.763.547.757.267,1.063.617,1.063,1.189A1.219,1.219,0,0,1,247.231,6.977Z",
    transform: "translate(-6329.933 -8618.063)",
    fill: "#04be76"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2040",
    "data-name": "Rectangle 2040",
    width: 22,
    height: 22,
    transform: "translate(-6092 -8622)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverPayoutActive);
export default __webpack_public_path__ + "static/media/driver_payout_active.68b6d3a8b41b2bcc98402153876243d1.svg";
export { ForwardRef as ReactComponent };